<div class="d-flex align-items-center justify-content-between">
  <p class="semi-bold w-40" data-id="departure-airport">
    {{ itinerary.departureAirport.locationCode }}
  </p>

  <div class="mx-4 mx-md-5 separator"></div>

  <ng-container [ngSwitch]="itinerary.segments.length - 1">
    <ng-container *ngSwitchCase="0">
      <nonstop-flight-badge [travelTime]="itinerary.travelTime" />
    </ng-container>

    <ng-container *ngSwitchDefault>
      <layover-badge [stops]="itinerary.segments.length - 1" [travelTime]="itinerary.travelTime" />
    </ng-container>
  </ng-container>

  <div class="mx-4 mx-md-5 separator"></div>

  <p class="semi-bold w-40 text-align-end" data-id="arrival-airport">
    {{ itinerary.finalDestinationAirport.locationCode }}
  </p>
</div>

<div class="d-flex align-items-center justify-content-between mt-1 g-2">
  <div class="d-flex align-items-center w-140">
    <p class="caption" data-id="departure-at-date">
      {{
        itinerary.segments[0].flightSegment.departureAtAirportTimeZone | withoutTimezone: 'MMM d'
      }}
    </p>

    <ds-dot-separator class="mx-2" />

    <p class="caption" data-id="departure-at">
      {{
        itinerary.segments[0].flightSegment.departureAtAirportTimeZone
          | withoutTimezone: 'hh:mma'
          | lowercase
      }}
    </p>
  </div>

  <div class="d-flex flex-wrap justify-content-center g-1">
    @for (
      segment of itinerary.segments;
      track segment;
      let index = $index;
      let first = $first;
      let last = $last
    ) {
      @let waitTime = segment.layover ? segment.layover.waitTime : null;

      @if (!last && waitTime) {
        <p class="caption">
          {{ waitTime | travelTime }} in
          {{ segment.flightSegment.arrivalAirport.locationCode }}
          @if (index < itinerary.segments.length - 2) {
            ,
          }
        </p>
      }
    }
  </div>

  <div class="d-flex align-items-center justify-content-end w-140">
    <p
      [ngClass]="{
        'text-sun-crete-800':
          (itinerary.daysShift | hasDaysShift) || (itinerary | hasDaysShiftAfterLayover),
      }"
      class="caption"
      data-id="arrival-at-date"
    >
      {{
        itinerary.segments[itinerary.segments.length - 1].flightSegment.arrivalAtAirportTimeZone
          | withoutTimezone: 'MMM d'
      }}
    </p>

    <ds-dot-separator class="mx-2" />

    <p class="caption" data-id="arrival-at">
      {{
        itinerary.segments[itinerary.segments.length - 1].flightSegment.arrivalAtAirportTimeZone
          | withoutTimezone: 'hh:mma'
          | lowercase
      }}
    </p>
  </div>
</div>
